import React from "react";
import PFlogo from "images/logo-dark.png";
import radioImage from "images/login/loginElement.svg";
import loginBackground from "images/login/loginBackground.svg";

import styles from "./styles.module.scss";

export const starterPlan = () => {

  return (
    <>
      <div className={styles.container}>
        <img alt="Paperflite Logo" className={styles.logo} src={PFlogo} />
        <img alt="Radio Logo" className={styles.logos} src={radioImage} />
      </div>
      <h1 className={styles.heading}>Houston, we have a (tiny) problem!</h1>

      <div className={styles.contentContainer}>
        <div className={styles.subText}>
          <p className={styles.text}>
            {" "}
            It looks like your team’s on the Starter plan, so the Chrome
            extension isn’t available just yet. Upgrade your plan to get on
            board.
          </p>
        </div>
      </div>
      <a
        href="https://www.paperflite.com/pricing"
        target="_blank"
        className={styles.button}
      >
        {" "}
        Get the extension now!{" "}
      </a>
      <div>
        <img
          alt="Half head man with audio waves in the background"
          className={styles.backgroundImage}
          src={loginBackground}
        />
      </div>
    </>
  );
};

export default starterPlan;
